import { render, staticRenderFns } from "./matrices-control.vue?vue&type=template&id=4002a820&"
import script from "./matrices-control.vue?vue&type=script&lang=js&"
export * from "./matrices-control.vue?vue&type=script&lang=js&"
import style0 from "./matrices-control.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports